<div
    (click)="onClick($event)"
    (mousedown)="onMouseDown()"
    (mouseout)="onMouseOut()"
    (mouseover)="onMouseOver()"
    (mouseup)="onMouseUp()"
    [class.disabled]="!isEnabled"
    [class.isOver]="isOver"
    [class.small]="small"
    [class.smaller]="smaller"
    [class.textOnRightImagebutton]="textOnRight"
    [ngClass]="cssMediaService.deviceCss('imagebutton')"
>
    <div
        [class.disabled-inner]="!isEnabled"
        [class.pressed]="isPressed"
        [class.textOnRightInner]="textOnRight"
        class="inner"
    >
        <img
            [alt]="tooltip"
            [class.imageOnLeftImagebutton]="textOnRight"
            [src]="source"
            [title]="tooltip"
            height="32"
            width="32"
        />
        <label [hidden]="!cssMediaService.isDesktop" class="se-imagebutton-label">{{ title }}</label>
    </div>
</div>
